import Confirm from './Confirm';
import Toast from './Toast';
import Vue from 'vue'
export function appenderFactory(component) {
  return {
    components: [],
    open(options) {
      let confirm = Vue.extend(component)
      let el = document.createElement('div')
      document.body.appendChild(el)
      let componentObj = new confirm({
        propsData: {appender:this,...options}
      })
      this.components.push(componentObj)
      componentObj.$mount(el)
      setTimeout(_=> componentObj.open(), 10)
      return this
    },
    close() {
      let componentObj = this.components.pop()
      componentObj.close(_=> {
        document.body.removeChild(componentObj.$el)
        componentObj.$destroy()
      })
    }
  }
}
export function getConfirm() {
  return appenderFactory(Confirm)
}
export function getToast() {
  return appenderFactory(Toast)
}